import { Helmet } from "react-helmet-async";

const DEFAULT = {
    title: "Dandy Builders & Property Care — Builders in Wokingham, Berkshire",
    description:
        "Friendly local builders in Wokingham, Berkshire. Extensions, loft conversions, groundworks, electrical and mechanical works. Fixed-price quotes, fully insured.",
    image:
        "https://images.unsplash.com/photo-1754063257992-bb9eabdbdd86?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
};

export default function Seo({ title, description, image, path = "/" }) {
    const fullTitle = title
        ? `${title} · Dandy Builders`
        : DEFAULT.title;
    const desc = description || DEFAULT.description;
    const img = image || DEFAULT.image;
    const url = `https://www.dandybuilders.co.uk${path}`;

    return (
        <Helmet prioritizeSeoTags>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={url} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Dandy Builders & Property Care" />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:image" content={img} />
            <meta property="og:url" content={url} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            <meta name="twitter:image" content={img} />
            <meta name="geo.region" content="GB-WOK" />
            <meta name="geo.placename" content="Wokingham, Berkshire" />
        </Helmet>
    );
}
